"use client";

export { DashboardRouteError as default } from "@components/Layout/DashboardRouteError";
